import React from 'react';
import TimeAgo from 'react-timeago';
import Box from '@rsos/components/capstone/base/Box';
import useReverseGeocode from '@rsos/maps/interface/reverseGeocode/useReverseGeocode';
import { reactTimeAgoFormatter } from '@rsos/utils/timeHelpers';
import useWhichReverseGeocodeService from '../../hooks/useWhichReverseGeocodeService';
import { StyledSource } from '../JurisdictionView/CallPane/CallPane.styles';
import { NoAddress } from './NoAddress';
import Uncertainty from './Uncertainty';
import { Loader } from './helpers';
import { MiddleText } from './styles/common.styles';
import {
  AddressContainer,
  SecondaryAddressWrapper,
} from './styles/locationAddress.styles';

/**
 * The secondary location component is rendered when the following conditions are true:
 * - The 911 event has a primary location (ELS)
 * - The 911 event has a secodary location (ANI/ALI) and the class of service value is WPH1 or WPH2
 * @param {Object} secondaryLocation
 * @param {Number} secondaryLocationIndex
 */
const SecondaryLocation = ({ secondaryLocation, secondaryLocationIndex }) => {
  const service = useWhichReverseGeocodeService();

  const { isReverseGeocoding } = useReverseGeocode({
    isSecondaryLocation: true,
    location: secondaryLocation,
    locationIndex: secondaryLocationIndex,
    service,
  });

  return (
    <AddressContainer px={3}>
      <SecondaryAddressWrapper br={'5px'} py={'13px'}>
        <Box px={3}>
          <StyledSource>
            Source: ANI/ALI ({secondaryLocation?.class_of_service}
            ),&nbsp;
            <TimeAgo
              date={secondaryLocation.location_time}
              formatter={reactTimeAgoFormatter}
              minPeriod={60}
              data-name="location-time-ago"
            />
          </StyledSource>
          <Box py={1}>
            {isReverseGeocoding ? (
              <Loader />
            ) : secondaryLocation?.address_single_line ||
              secondaryLocation?.rgAddress ? (
              <MiddleText wrap="true">
                {secondaryLocation?.address_single_line ||
                  secondaryLocation?.rgAddress}
              </MiddleText>
            ) : (
              <NoAddress secondary />
            )}
          </Box>
        </Box>
        <Uncertainty
          uncertaintyRadius={secondaryLocation.uncertainty_radius}
          secondary
        />
      </SecondaryAddressWrapper>
    </AddressContainer>
  );
};

export default SecondaryLocation;
